import React, { useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import styled from "styled-components/macro";

import { Constants, Carousel, Button } from "../odc-ui";
import { Frame } from "@bitesite/react-figstrap";

import {
  dermatologyPrepaidSlideContents,
  dermatologyPrepaidWriteupContents,
  surgeryPrepaidSlideContents,
  surgeryPrepaidWriteupContents,
} from "../components/purchase_section/purchase_section_data";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 100px 0;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    flex-direction: column-reverse;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    padding: 100px 40px;
  }
`;

const WriteupContainer = styled.div`
  width: 350px;
  padding: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    width: 100%;
    padding: 75px 0 0 0;
  }
`;

const WriteupContent = styled.div`
  padding-bottom: 100px;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    padding: 0;
  }
`;

const CarouselContainer = styled.div`
  width: 500px;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    width: 100%;
  }
`;

const PrepaidPurchaseSection = ({ treatmentCategory }) => {
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);

  const renderCardWriteup = () => {
    const writeupContents =
      treatmentCategory === "dermatology"
        ? dermatologyPrepaidWriteupContents
        : surgeryPrepaidWriteupContents;
    return (
      <Frame vertical gap={20} alignItems="center">
        {writeupContents[selectedCardIndex].writeupText}
        <Button type="dark" href={writeupContents[selectedCardIndex].buyNowUrl}>
          Buy now
        </Button>
      </Frame>
    );
  };

  return (
    <Container>
      <WriteupContainer>
        <WriteupContent>{renderCardWriteup()}</WriteupContent>
      </WriteupContainer>
      <CarouselContainer>
        <Carousel
          slideContents={
            treatmentCategory === "dermatology"
              ? dermatologyPrepaidSlideContents
              : surgeryPrepaidSlideContents
          }
          onSlideDotClicked={(index) => setSelectedCardIndex(index)}
        />
      </CarouselContainer>
    </Container>
  );
};

PrepaidPurchaseSection.propTypes = {
  treatmentCategory: PropTypes.string.isRequired,
};

document.addEventListener("DOMContentLoaded", () => {
  const mountPoint = document.getElementById(
    "prepaid-purchase-section-mount-point"
  );

  if (mountPoint) {
    const { treatmentCategory } = mountPoint.dataset;
    ReactDOM.render(
      <PrepaidPurchaseSection treatmentCategory={treatmentCategory} />,
      mountPoint
    );
  }
});
